var data = {
  "width": 24,
  "height": 24,
  "body": "<g id=\"evaMinusSquareOutline0\"><g id=\"evaMinusSquareOutline1\"><g id=\"evaMinusSquareOutline2\" fill=\"currentColor\"><path d=\"M18 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3Zm1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Z\"/><path d=\"M15 11H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Z\"/></g></g></g>"
};
exports.__esModule = true;
exports.default = data;